<template>
  <el-dialog
    title="Đổi mật khẩu"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    :show-close="showClose"
    @close="handleClose"
  >
    <div class="password-form">
      <div class="form-group">
        <label class="form-label">
          Mật khẩu hiện tại
        </label>

        <el-input
          v-model="form.old_password"
          type="password"
          show-password
          placeholder="Nhập mật khẩu hiện tại"
        >
          <template slot="prefix">
            <img
              src="@/static/icon/changePw/icon1.svg"
              class="input-icon"
              alt=""
            >
          </template>
        </el-input>
      </div>

      <div class="form-group">
        <label class="form-label">
          Mật khẩu mới
        </label>

        <el-input
          v-model="form.new_password"
          type="password"
          show-password
          placeholder="Tối thiểu 8 ký tự"
        >
          <template slot="prefix">
            <img
              src="@/static/icon/changePw/icon2.svg"
              class="input-icon"
              alt=""
            >
          </template>
        </el-input>
      </div>

      <div class="form-group">
        <label class="form-label">
          Xác nhận mật khẩu mới
        </label>

        <el-input
          v-model="form.confirm_password"
          type="password"
          show-password
          placeholder="Nhập lại mật khẩu mới"
        >
          <template slot="prefix">
            <img
              src="@/static/icon/changePw/icon2.svg"
              class="input-icon"
              alt=""
            >
          </template>
        </el-input>
      </div>


      <TxtValidatePw></TxtValidatePw>


    </div>

    <div slot="footer" class="dialog-footer">


      <el-button
        type="primary"
        class="btn-submit"
        :loading="!canSubmit"
        :disabled="!canSubmit"
        @click="submit"
      >
        Đổi mật khẩu
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import axios from 'axios'
  import TxtValidatePw from "@/components/TxtValidatePw";
  import AuthLogin from "@/AuthLogin";
  import {mapActions} from "vuex";

  export default {
    name: 'ChangePasswordDialog',
    props: {
      showClose: {
        type: Boolean,
        default: true
      }
    },
    components: {
      TxtValidatePw,
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        canSubmit: true,
        form: {
          old_password: '',
          new_password: '',
          confirm_password: ''
        }
      }
    },

    methods: {
      ...mapActions("account", ["removeAccountInfo"], ["getAccountInfo"]),

      open() {
        this.dialogVisible = true
      },

      handleClose() {
        this.form = {
          old_password: '',
          new_password: '',
          confirm_password: ''
        }
      },

      validatePassword() {
        const { old_password, new_password, confirm_password } = this.form

        if (!old_password) {
          this.$message.error('Vui lòng nhập mật khẩu hiện tại')
          return false
        }

        if (!new_password) {
          this.$message.error('Vui lòng nhập mật khẩu mới')
          return false
        }

        const rules = [
          {
            valid: new_password.length >= 8,
            message: 'Mật khẩu mới phải có tối thiểu 8 ký tự'
          },
          {
            valid: /[A-Z]/.test(new_password),
            message: 'Mật khẩu mới phải chứa ít nhất 1 chữ cái viết hoa'
          },
          {
            valid: /[a-z]/.test(new_password),
            message: 'Mật khẩu mới phải chứa ít nhất 1 chữ cái viết thường'
          },
          {
            valid: /\d/.test(new_password),
            message: 'Mật khẩu mới phải chứa ít nhất 1 chữ số'
          },
          {
            valid: /[^A-Za-z0-9]/.test(new_password),
            message: 'Mật khẩu mới phải chứa ít nhất 1 ký tự đặc biệt'
          },
          {
            valid: new_password !== old_password,
            message: 'Mật khẩu mới không được trùng với mật khẩu hiện tại'
          },
          {
            valid: !!confirm_password,
            message: 'Vui lòng nhập xác nhận mật khẩu mới'
          },
          {
            valid: new_password === confirm_password,
            message: 'Mật khẩu xác nhận không khớp'
          }
        ]

        const error = rules.find(rule => !rule.valid)

        if (error) {
          this.$message.error(error.message)
          return false
        }

        return true
      },

      submit() {
        if (!this.validatePassword()) {
          return
        }
        let data = {
          password_old: this.form.old_password,
          password: this.form.new_password,
          password_confirmation: this.form.confirm_password,
        };
        this.canSubmit = false;
        axios.post("auth/change-password", data).then((response) => {
          this.canSubmit = true;
          console.log(response.code)
          switch (response.code) {
            case 200:
              this.$message.success('Đổi mật khẩu thành công')
              this.dialogVisible = false;
              this.$router.push({ name: "account-login" });
              AuthLogin.logout();
              this.removeAccountInfo();
              this.$emit('success')
              break;
            case 422:
              this.$notify({
                title: "có lỗi xảy ra",
                message: Object.values(response.data)[0],
                type: "warning",
              });
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },



    }
  }
</script>
<style scoped>
.password-form {
    padding: 8px 0;
}

.form-group {
    margin-bottom: 22px;
}

.form-label {
    display: block;
    margin-bottom: 8px;
    color: #1f2937;
    font-size: 14px;
    font-weight: 600;
}

.dialog-footer {
    display: flex;
    justify-content: center;
    gap: 12px;
}

/* Dialog */
::v-deep .el-dialog {
    border-radius: 16px;
    overflow: hidden;
}

::v-deep .el-dialog__header {
    padding: 24px;
    border-bottom: 1px solid #f1f5f9;
}

::v-deep .el-dialog__title {
    font-size: 20px;
    font-weight: 700;
    color: #111827;
}

::v-deep .el-dialog__body {
    padding: 24px;
}

::v-deep .el-dialog__footer {
    padding: 20px 24px;
    border-top: 1px solid #f1f5f9;
}

/* Input */
::v-deep .el-input__inner {
    height: 48px;
    border-radius: 10px;
    border: 1px solid #dbe2ea;
    transition: all .2s;
    font-size: 14px;
}

::v-deep .el-input__inner:focus {
    border-color: #409eff;
}

/* Button */
.btn-cancel {
    height: 42px;
    min-width: 110px;
    border-radius: 10px;
}

.btn-submit {
    height: 42px;
    min-width: 140px;
    border-radius: 10px;
    font-weight: 600;
}

/* Header icon close */
::v-deep .el-dialog__headerbtn {
    top: 24px;
    right: 24px;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
    font-size: 18px;
    font-weight: 600;
}

/* Overlay */
::v-deep .v-modal {
    opacity: .6;
}
::v-deep .el-input__prefix {
    left: 10px;
    display: flex;
    align-items: center;
}

::v-deep .el-input__inner {
    padding-left: 40px !important;
    height: 48px;
    border-radius: 10px;
}
.password-note {
    margin-top: 16px;
    padding: 14px 16px;
    background: #fff8e6;
    border: 1px solid #ffe58f;
    border-radius: 10px;
}

.password-note-title {
    font-size: 14px;
    font-weight: 600;
    color: #d48806;
    margin-bottom: 8px;
}

.password-note ul {
    margin: 0;
    padding-left: 18px;
}

.password-note li {
    color: #595959;
    font-size: 13px;
    line-height: 24px;
}
</style>
